import React, { useRef, useState } from "react";

import { SliderItem } from "../index";
import { useSelector } from "react-redux";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

const SliderList = () => {
  const categoriesParent = useSelector((state) => state.categoriesParent.list);
  const [isChangeSlider, setChangeSlider] = useState(true);

  return (
    <Slide
      onChange={() => {
        setChangeSlider(!isChangeSlider);
      }}
    >
      {categoriesParent &&
        categoriesParent.map((item, index) => {
          return (
            <SliderItem
              imgPath={item.imgPath}
              label={`${item.name} Phong Thủy`}
              id={item.id}
              onChange={isChangeSlider}
              key={index}
            />
          );
        })}
    </Slide>

    // <div className={styles.slider}>
    /* <figure style={{ left: `${value}` }}>
        {categoriesParent &&
          categoriesParent.map((item, index) => {
            return (
              <SliderItem
                imgPath={item.imgPath}
                label={`${item.name} Phong Thủy`}
                id={item.id}
                key={index}
              />
            );
          })}
      </figure> */

    // </div>
  );
};

export default SliderList;
